import type { ComponentProps } from "react";
import { Banknote, BookOpenText, Cog, HelpCircleIcon, Presentation } from "lucide-react";
import { t } from "@lingui/core/macro";
import { SidebarHeader, Sidebar, SidebarContent, SidebarFooter } from "@/components/ui/sidebar.tsx";
import { Separator } from "@/components/ui/separator.tsx";
import { AppSwitch } from "@/modules/layout/components/AppSwitch.tsx";
import { NavSection } from "@/modules/layout/components/NavSection.tsx";
import { NavLinks } from "@/modules/layout/components/NavLinks.tsx";
import { NavUserMenu } from "@/modules/layout/components/NavUserMenu.tsx";
import image from "../../../assets/finbricks-basic.svg";
import { Trans } from "@lingui/react/macro";
import { CUSTOMER_SUPPORT_URL } from "@/lib/utils.ts";
import { CONFIG } from "@/lib/config.ts";

export function AppSidebar({ ...props }: ComponentProps<typeof Sidebar>) {
  const data = {
    navLinks: [
      {
        title: t`Get Help`,
        url: CUSTOMER_SUPPORT_URL,
        icon: HelpCircleIcon,
      },
      {
        title: t`Tutorial`,
        url: CONFIG.TUTORIAL_URL,
        icon: Presentation,
      },
      {
        title: t`Documentation`,
        url: CONFIG.DOCS_URL,
        icon: BookOpenText,
      },
    ],
    payments: [
      {
        name: t`Domestic payments`,
        url: "/payments/domestic",
      },
      {
        name: t`Sepa payments`,
        url: "/payments/sepa/",
      },
      {
        name: t`Foreign payments`,
        url: "/payments/foreign/",
      },
      {
        name: t`Pairing payments`,
        url: "/payments/pairing/",
      },
    ],
    settings: [
      {
        name: t`Security`,
        url: "/settings/security/",
      },
      {
        name: t`Bank settings`,
        url: "/settings/banks/",
      },
      {
        name: t`Users administration`,
        url: "/settings/users/",
      },
      {
        name: t`Accounts management`,
        url: "/settings/accounts/",
      },
    ],
  };

  return (
    <Sidebar {...props}>
      <SidebarHeader>
        <a href={"https://www.finbricks.com/"}>
          <div className={"flex items-center gap-4 p-2"}>
            <img src={image} alt={"Finbricks Logo"} width="40" height="40" />
            <span className="text-base font-semibold">
              <Trans>Finbricks</Trans>
            </span>
          </div>
        </a>
      </SidebarHeader>
      <SidebarContent>
        <Separator />
        <AppSwitch className={"px-1"} />
        <Separator />
        <NavSection items={data.payments} label={{ icon: Banknote, text: t`Payments` }} />
        <NavSection items={data.settings} label={{ icon: Cog, text: t`Settings` }} />
        <NavLinks items={data.navLinks} className="mt-auto" />
      </SidebarContent>
      <Separator />
      <SidebarFooter className={"bg-sidebar-accent rounded-lg mt-2"}>
        <NavUserMenu />
      </SidebarFooter>
    </Sidebar>
  );
}
